module.exports = __webpack_public_path__ + "static/media/fin_dwn1.8255930c.jpg";